// Service-worker registration with application-side error reporting.
//
// Decisions (2026-09-14 perf session):
//  - No Sentry SDK inside the service worker itself (deliberate: the SW stays a
//    zero-dependency Workbox bundle). Instead, registration/update failures are
//    reported here, from the application context where Sentry is already live.
//  - The SW only precaches the app shell + fonts; /api is never intercepted
//    (TanStack DB owns API caching).
import * as Sentry from '@sentry/browser';
import { registerSW } from 'virtual:pwa-register';

let registered = false;

/**
 * Registers the generated service worker (production builds only).
 * Safe to call multiple times; registration is attempted once.
 */
export function registerServiceWorker(): void {
  if (registered || !import.meta.env.PROD) {
    return;
  }
  registered = true;

  try {
    registerSW({
      immediate: true,
      onRegisterError(error: unknown) {
        // iOS privacy mode, user opt-outs, or transient failures land here.
        Sentry.captureException(error instanceof Error ? error : new Error(String(error)), {
          tags: { area: 'service-worker' },
        });
      },
      onNeedRefresh() {
        // New version available; activation happens on next navigation via
        // autoUpdate — nothing to do, kept for observability hookups later.
      },
    });
  } catch (error) {
    Sentry.captureException(error instanceof Error ? error : new Error(String(error)), {
      tags: { area: 'service-worker' },
    });
  }
}
